import urls from './urls'
import Service from '@/utils/fetch'

// 获取纪念堂列表
export function _findUserList(data) {
  return Service({
    url: urls.findUserList,
    data
  })
}

// 用户详情
export function _findById(data) {
  return Service({
    url: urls.findById,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/UserM/index.js